<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>
    <v-menu
      ref="menu"
      :close-on-content-click="false"
      :return-value.sync="value"
      v-bind="schema.attributesMenu"
      v-model="menu"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :name="schema.model"
          :id="generateId(schema.model)"
          slot="activator"
          v-model="value"
          v-bind="schema.attributesTextField"
          :disabled="schema.readonly"
          :rules="rules"
          @change="onChange"
          @focus="onFocus"
          @input="onInput"
          @click:clear="clear()"
          v-on="on"
        >
          <template v-slot:label>
            {{ schema.attributesTextField.label }}
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-text-field>
      </template>

      <v-time-picker
        v-if="!schema.attributesTextField.readonly"
        v-model="value"
        @change="$refs.menu.save(value)"
        v-bind="schema.attributesTimePicker"
        @click:minute="$refs.menu.save(time)"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';
export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    menu: false
  }),

  watch: {
    modal(newValue) {
      if (this.schema.attributesTextField.readonly) this.modal = false;
    }
  },

  methods: {
    onChange: async function () {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },
  }
};
</script>
